import { call, put, select } from "redux-saga/effects";
import cirrusClient from "../../../services/api/cirrus-client";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { setDomainCallReport } from "../../../state/callCenter/domainCallReportSlice";
import { selectUserCredentials } from "../../../state/userCredential/userCredentialSlice";

dayjs.extend(utc);

export function* fetchDomainCallReportSaga(action) {
    const { reportType, timeframe } = action.payload;
    try {
        const { domain } = yield select(selectUserCredentials)

        const reportObject = reportType === 'volume' ? 'cdr2' : 'call';

        const getDateRange = () => {
            if (timeframe === 'hourly') {
                if (reportType === 'peak') {
                    // Peak hourly: 13 days
                    return {
                        start_date: dayjs().subtract(13, "day").utc().format("YYYY-MM-DD HH:mm:ss"),
                        end_date: dayjs().utc().format("YYYY-MM-DD HH:mm:ss")
                    };
                } else {
                    // Volume hourly: 15 days
                    return {
                        start_date: dayjs().subtract(15, "day").utc().format("YYYY-MM-DD HH:mm:ss"),
                        end_date: dayjs().utc().format("YYYY-MM-DD HH:mm:ss")
                    };
                }
            } else { // daily: : 6 month
                return {
                    start_date: dayjs().subtract(6, "month").utc().format("YYYY-MM-DD HH:mm:ss"),
                    end_date: dayjs().utc().format("YYYY-MM-DD HH:mm:ss")
                };
            }
        };


        const apiUrl = `?object=${reportObject}&action=report&format=json`;
        const params = {
            ...getDateRange(),
            type: 'all',
            report_by: timeframe === 'hourly' ? 'hour' : 'day',
            domain: domain,
        };
        const response = yield call(cirrusClient.get, apiUrl, { params });
        yield put(setDomainCallReport({
            reportType,
            timeframe,
            data: response.data
        }));


    } catch (error) {
        console.error('Error fetching daily call report', error)

    }

}